import React from 'react';
import cx from 'classnames';

import Divider from '../Divider';
import Icon from '../Icon';
import Text from '../Text';

import styles from './ToastNotification.module.scss';
import usePresenter from './ToastNotification.presenter';
import getProps from './ToastNotification.props';
import { ToastNotificationCombinedProps } from './types';


const ToastNotification: React.FC<ToastNotificationCombinedProps> = (props) => {
  const {
    type,
    className,
    classes,
    divider,
    icon,
    text,
  } = usePresenter(props);

  const variantName = `${type}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`toastNotification${variantName}`];

  let componentView;

  switch (variantName) {
    case 'Critical':
    case 'Info':
    case 'Success': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Divider
            className={cx(styles.divider, classes?.divider)}
            {...internalProps.divider}
            {...divider}/>
          <div className={cx(styles.content, classes?.content)}>
            <Icon
              className={cx(styles.icon, classes?.icon)}
              {...internalProps.icon}
              {...icon}/>
            <Text
              className={cx(styles.text, classes?.text)}
              {...internalProps.text}
              {...text}/>
          </div>
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default ToastNotification;

